import { addSegmentEventListeners } from './addSegmentEventListeners';
import { convertFragmentToSegment } from './convertFragmentToSegment';
export const initSegment = (playerContext, options) => {
    const { segment, fragment } = options;
    const activeSegment = fragment ? convertFragmentToSegment(fragment) : segment;
    if (activeSegment) {
        playerContext.player.seek(activeSegment.inpoint);
        addSegmentEventListeners(playerContext, activeSegment);
    }
};
